import { Component, Input, OnInit } from '@angular/core';

import { Product } from './products/product';
import { ProductsService } from './products/products.service';

@Component({
  selector: 'app-business-areas',
  templateUrl: './business-areas.component.html',
  styleUrls: ['./business-areas.component.css']
})
export class BusinessAreasComponent implements OnInit {

  @Input() onShowPeriod;
  @Input() showGoals;
  @Input() showTrends;
  @Input() showRating;
  @Input() onFlexGrid;
  @Input() onEdit;

  products: Product [];
  mockProducts: Product [] = [];

  constructor(
    private _productsService: ProductsService) {}

  getProducts(): void {
    this._productsService.getProducts().then(products => this.products = products);
  }

  getMockProducts(): void {
    this._productsService.getMockProducts().then(mockProducts => this.mockProducts = mockProducts);
  }

  ngOnInit(): void {
    this.getMockProducts();
    this.getProducts();
  }

  transferDataSuccess($event: any) {
    console.log(this.mockProducts);
    const newProduct: Product = $event.dragData;
    for (let indx in this.mockProducts) {
        let prod: Product = this.mockProducts[indx];
    }
    this.mockProducts.unshift(newProduct);
  }

  deleteProduct(prod: Product): void {
    const index: number = this.mockProducts.indexOf(prod);
    if (index !== -1) {
      this.mockProducts.splice(index, 1);
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/business-areas/business-areas.component.ts